// Мутации пагинация
export const SET_PAGE = 'setPage';
export const SET_PAGE_SIZE = 'setPageSize';
export const SET_TOTAL = 'setTotal';
export const RESET_PAGING = 'resetPaging';
